import { createRoute, useEntityUrl } from 'framework/routing';

const applicationsPath = '/applications';

export const useApplicationsRoute = () => createRoute({ listRoute: applicationsPath });

export const useApplicationsUrl = () => useEntityUrl({ baseLink: applicationsPath });

export const applicationsRouterPath = () => `${applicationsPath}/*`;
